<div class="stats-panel">

  <div class="streak-line" *ngIf="overallStreak > 0">
    <span class="flame">🔥</span>
    <span class="streak-num">{{ overallStreak }}</span>
    <span class="streak-label">day{{ overallStreak === 1 ? '' : 's' }} best streak</span>
  </div>

  <div class="progress-row">
    <span class="progress-label">{{ dailyProgress.complete }}/{{ dailyProgress.total }} daily</span>
    <div class="progress-bar"><div class="progress-fill" [style.width.%]="dailyPct"></div></div>
  </div>

  <div class="progress-row" *ngIf="weeklyProgress.total > 0">
    <span class="progress-label">{{ weeklyProgress.complete }}/{{ weeklyProgress.total }} weekly</span>
    <div class="progress-bar"><div class="progress-fill" [style.width.%]="weeklyPct"></div></div>
  </div>

  <div class="category-list" *ngIf="rings.length">
    <div class="cat-row" *ngFor="let r of rings">
      <span class="cat-dot" [style.background]="r.color"></span>
      <span class="cat-name">{{ r.category }}</span>
      <span class="cat-streak">{{ r.streak }}d</span>
      <span class="cat-dots" aria-hidden="true">
        <span class="cat-d" *ngFor="let on of r.last5; trackBy: trackDotIndex; let i = index" [class.on]="on"></span>
      </span>
    </div>
  </div>

</div>
